import styles from './GrupoTable.module.css'

function  GrupoTable({grupos}) {

    let grupoAnterior = null

    return (
        <div className={styles.tableWrapper}>
        <table className={styles.table}>
            <thead>
            <tr>
                <th className={styles.tableDescricao}>Grupo</th>
                <th className={styles.tableDescricao}>Empresa</th>
                <th className={styles.tableIDHead}>Qtd. Chamados</th>
            </tr>
            </thead>
            <tbody>
            {grupos.map((grupo, indice) => {
                const novoGrupo = grupo.TX_NOME_GRUPO !== grupoAnterior
                grupoAnterior = grupo.TX_NOME_GRUPO
                return (
                    <tr key={`grupo-${indice}`} className={novoGrupo ? styles.novoGrupo : undefined}>
                        <td className={styles.tableDesc}>{novoGrupo ? grupo.TX_NOME_GRUPO : ''}</td>
                        <td className={styles.tableDesc}>{grupo.TX_NOME_EMPRESA}</td>
                        <td className={`${styles.tableID} ${parseInt(grupo.QTD) === 0 ? styles.tableIDZero : ''}`}>{grupo.QTD}</td>
                    </tr>
                )
            })}
            </tbody>
        </table>
        </div>
        )

    }

export default GrupoTable
